import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { NavMenuImageCard } from '../../../../../../design-system/components/nav/nav-menu-image-card/NavMenuImageCard';
import { WhereToGoMenu } from '../../../../../../resources/whereToGoMenu/domain/types/whereToGoMenu';
import { useUrlGenerator } from '../../../../../../shared/hooks/useUrlGenerator';

import style from './HowLongTabContent.module.css';

type HowLongTabContentProps = {
    howLong: WhereToGoMenu['howLong'];
};

export function HowLongTabContent({ howLong }: HowLongTabContentProps) {
    const { generatePath } = useUrlGenerator();
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div className={style.tabContent}>
            {howLong.thematics.map((thematic, index) => (
                <NavMenuImageCard
                    key={`${thematic.hubpage.id}-${thematic.label}`}
                    label={thematic.label}
                    blur={true}
                    href={generatePath('hub_thematic', {
                        thematicSlug: thematic.hubpage.slug,
                    })}
                    image={{
                        alt: thematic.hubpage.coverPicture.card_cover_mobile.alt,
                        src: thematic.hubpage.coverPicture.card_cover_mobile.url,
                        loading: 'lazy',
                        unoptimized: true,
                    }}
                    onClick={() => {
                        trackEvent((ampli, defaultProperties) => {
                            ampli.primaryNavThematicClicked({
                                ...defaultProperties,
                                block: 'primary_nav',
                                card_number: index + 1,
                                row_number: 4,
                                thematic_slug: thematic.hubpage.slug,
                                click_type: 'card',
                                column_number: 0,
                                thematic_group: 'how_long',
                            });
                        });
                    }}
                />
            ))}
        </div>
    );
}
